import React, { useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, IconButton, Chip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import _ from 'lodash';

export function CustomTable({ tableData, setEditProduct,setPagination,pagination , globalFilter , setGlobalFilter }) { 
   const columns = useMemo(
       () => [
           {
               accessorKey: 'productName',
               header: 'Crop',
               size: 100,
           },
           {
               accessorKey: 'varietyName',
               header: 'Crop Variety',
               size: 100,
           },
           {
               accessorKey: 'cultivationTypeID',
               header: 'Cultivation Type',
               size: 100,
               Cell: ({ cell }) => (cell.getValue() === 1 ? 'Greenhouse' : 'Non Greenhouse'),
           },
           {
               accessorKey: 'daysToHarvest',
               header: 'Days To Harvest',
               size: 100,
               Cell: ({ cell }) => (cell.row.original.isSeasonal === false ? cell.getValue() : '-'),
           },
           {
            accessorKey: 'harvestingPeriodType',
            header: 'Harvesting Period',
            size: 100,
            Cell: ({ cell }) => {
                const rowData = cell.row.original;
                if (!rowData.isSeasonal) {
                    const period = rowData.harvestingPeriod;
                    let periodType;
                    switch (cell.getValue()) {
                        case 1:
                            periodType = 'Days';
                            break;
                        case 2:
                            periodType = 'Weeks';
                            break;
                        case 3:
                            periodType = 'Months';
                            break;
                        default:
                            periodType = '';
                    }
                    return `${period} ${periodType}`;
                }
                return '-';
            },
           },   
            
           {
               accessorKey: 'yield',
               header: 'Yield (Potential)',
               size: 100,
           },
           {
               accessorKey: 'harvestingIntervals',
               header: 'Harvesting Interval (Days)',
               size: 100,
           },
           {
               accessorKey: 'isActive',
               header: 'IsActive',
               size: 100,
               Cell: ({ cell }) => cell.getValue() ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />,
           },
            {
                accessorKey: 'action',
                header: 'Action',
                size: 100,
                Cell: ({ row }) => (
            <IconButton aria-label="edit" onClick={() => EditProduct(row.original.productLifeCycleID)}>
            <EditIcon />
            </IconButton>
                ),
            },
       ],
       []
   );

   function EditProduct(productLifeCycleID) {
    setEditProduct(productLifeCycleID)
}
   const table = useMaterialReactTable({
       columns,
       data: tableData,
   });
//    const [pagination, setPagination] = useState({
//     pageIndex: 0,
//     pageSize: 5, 
//   });
   return (
<div>
<MaterialReactTable
               columns={columns}
               data={tableData}
               enableFullScreenToggle={false}
               enableHiding={false}
               enableColumnActions={false}
               onPaginationChange={setPagination}
               // manualFiltering
               onGlobalFilterChange = {setGlobalFilter}
               state={{ pagination,globalFilter }}
               initialState={{ density: 'compact', showGlobalFilter: true }}
           />
</div>
   );
}